import React from 'react';
import PetReleaseCard from './PetReleaseCard';
import CosmeticReleaseStrip from './CosmeticReleaseStrip';
import { RELEASE_PETS, SEASONAL_PET, RELEASE_NAME } from './releaseCatalog';
import '../../styles/release.css';

export default function ReleaseHero() {
  return (
    <section className="release-hero" aria-labelledby="release-hero-title">
      <div className="release-hero-head">
        <span className="release-hero-eyebrow">{RELEASE_NAME}</span>
        <h2 id="release-hero-title" className="release-hero-title">
          New Petlings, <em>hand-crafted and free to earn.</em>
        </h2>
        <p className="release-hero-sub">
          Eight brand-new companions, all available with treats - not dollars.
        </p>
        <p className="release-hero-pitch">
          Treats land in your wallet just for logging in, plus bonus drops during events. Play, or pay.
        </p>
      </div>

      <div className="release-pet-grid">
        {RELEASE_PETS.map((pet) => (
          <PetReleaseCard
            key={pet.id}
            id={pet.id}
            name={pet.name}
            gifUrl={pet.gif}
            staticUrl={pet.still}
          />
        ))}
        <PetReleaseCard
          id={SEASONAL_PET.id}
          name={SEASONAL_PET.name}
          gifUrl={SEASONAL_PET.gif}
          pill={SEASONAL_PET.pill}
          featured
        />
      </div>

      <CosmeticReleaseStrip />
    </section>
  );
}
